import { createContext, useState } from 'react';

const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [userID, setUserID] = useState(null);
    const [sessionID, setSessionID] = useState(null);
    const [flimpID, setFlimpID] = useState(null);

    const setUserData = (newUserID, newSessionID, newFlimpID) => {
        setUserID(newUserID);
        setSessionID(newSessionID);
        setFlimpID(newFlimpID);
    };

    return (
        <UserContext.Provider value={{ userID, sessionID, flimpID, setUserData }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };